var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimuleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Simule_icon",
    "data-name": "Simule icon",
    transform: "translate(248.467 -539.326)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681",
    "data-name": "Rectangle 1681",
    width: 54,
    height: 54,
    rx: 10,
    transform: "translate(-248.467 539.326)",
    fill: "#bef437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M-196.988,578.774l-7.525-4.619-1.4-.858-7.292-4.477,6.595-4.049h0a1.007,1.007,0,0,0,0-1.716h0l-6.595-4.049-.441-.27a1.83,1.83,0,0,0-1.914,0l-.441.27-6.595,4.049-1.4.859-7.292,4.476h0a1.007,1.007,0,0,0,0,1.717h0l6.595,4.048,1.4.859L-216,579.49l-7.525,4.619h0a1.007,1.007,0,0,0,0,1.716h0l7.525,4.619.441.271a1.83,1.83,0,0,0,1.914,0l.441-.271,7.525-4.619,1.4-.858,7.292-4.477h0a1.007,1.007,0,0,0,0-1.716ZM-214.6,559.866l6.595,4.048-6.595,4.048-6.595-4.048Zm-15.285,9.383,7.292-4.477,6.595,4.049-7.292,4.477Zm7.993,4.906,7.292-4.477,7.292,4.477-7.292,4.477Zm7.292,15.432-7.525-4.619,7.525-4.619,7.525,4.619Zm8.923-5.478-7.525-4.619,7.292-4.476,7.525,4.619Z",
    transform: "translate(-7.33 -8.4)",
    fill: "#383838"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimuleIcon);
export default __webpack_public_path__ + "static/media/Simule_icon.e379605f09fd68938be6241ff2110cb1.svg";
export { ForwardRef as ReactComponent };